import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Market } from '../constants';

/**************************/
/* This service should not exist. We need to provide a market service to load all of the tasks in business app
/* and instead of providing this as a stub we should fix the providing of task definitions to only be the one
/* for the relevant centers
/**************************/

@Injectable({ providedIn: 'root' })
export class BusinessAppMarketsService {
  markets$: Observable<Market[]> = of([]);
}
